import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './CheckBoxGroupInput.css'
import {asField} from '$src/common/forms'

interface Props {
  css?: any
  name: string
  label: string
  placeholder?: string
  value: any[]
  options: Array<{label: string; value: string}>
  onChange: (v: any) => void
}

interface State {}

@observer
export default class RadioGroupInput extends Component<Props, State> {
  static Field: any

  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container')}>
        <div {...classes('label')}>{props.label}</div>

        {props.options.map(({label, value}) => {
          const isOn = String(value) === String(props.value)
          return (
            <label key={`label-${value}`} {...classes('item', isOn ? 'on' : '')}>
              <input
                type="radio"
                key={`value-${value}`}
                checked={isOn}
                onChange={(e: any) => {
                  props.onChange(value)

                }}
              />
              <div className={css.itemLabel}>{label}</div>
            </label>
          )
        })}
      </div>
    )
  }
}
RadioGroupInput.Field = asField()(RadioGroupInput)



// WEBPACK FOOTER //
// ./src/common/RadioGroupInput.tsx